import Axios from "../../configs/axios.config";

export const createDeduction = (data) => Axios.post(`/salary/deduction`, data).then(response => response.data.data);
export const updateDeduction = (data, id) => Axios.put(`/salary/deduction/${id}`, data);
export const getDeductionList = (data) => Axios.get('/salary/deduction', { params: data }).then(response => response.data);
export const getDeductionDetail = (id) => Axios.get(`/salary/deduction/${id}`).then(response => response.data.data);
export const deleteDeduction = (id) => Axios.delete(`/salary/deduction/${id}`); 
 